import { useState, useEffect } from "react";
import { Product } from "../types/productTypes";
import api from "../../../../../features/auth/axiosConfig";
import { notifyError } from "../../../../../assets/toastService";

export const useProducts = (showDeleted: boolean, page: number, rowsPerPage: number, search: string, categoryFilter: string) => {
  const [products, setProducts] = useState<Product[]>([]);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchProducts = async () => {
    setLoading(true);

    try {
      let apiUrl = `/app/v1/pos/product?include_deleted=${showDeleted}&pageNumber=${page + 1}&pageSize=${rowsPerPage}`;

      if (search) {
        apiUrl += `&searchBy=${search}`;
      }

      if (categoryFilter && categoryFilter !== "all") {
        apiUrl += `&category_id=${categoryFilter}`;
      }

      const response = await api.get(apiUrl);
      const productsData = response.data.result.map((product: any) => ({
        ...product,
        staff_list: Array.isArray(product.staff_list)
          ? product.staff_list.map((staff: any) => ({
              name: typeof staff === "string" ? staff : staff.name || staff.staff_name || "",
            }))
          : [],
      }));

      setProducts(productsData);
      setTotalRecords(response.data.totalRecords);
    } catch (error) {
      console.error("Error fetching products:", error);
      notifyError("Failed to fetch products");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, [showDeleted, page, rowsPerPage, search, categoryFilter]);

  const refetchProducts = () => {
    fetchProducts();
  };

  return { products, totalRecords, loading, refetchProducts };
};
